import { IS_WEB } from 'constants/platform'
import React from 'react'
import { StyleSheet } from 'react-native'

import { Box } from 'widgets/Box'
import { FlatList } from 'widgets/FlatList'
import { Title } from 'widgets/Title'

import { TagGroup } from 'types/workoutTag'

import { Tag } from './Tag'

type WrapableTagsLayoutProps = {
  data: TagGroup
  hideTitle?: boolean
  selectedItems?: string[]
  onSelect?: (index: number) => void
}

const styles = StyleSheet.create({
  contentContainerStyle: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
})

export const WrapableTagsLayout = ({
  data,
  selectedItems,
  hideTitle = false,
  onSelect,
}: WrapableTagsLayoutProps) => {
  return (
    <Box>
      {!hideTitle && data.name && (
        <Box margin={{ top: 'xxs', bottom: 'smd' }}>
          <Title size='xs' bold>
            {data.name}
          </Title>
        </Box>
      )}

      <Box flexDirection={IS_WEB ? 'column' : 'row'} margin={{ vertical: 'xs' }}>
        <FlatList<string>
          bounces={false}
          data={data.tags}
          contentContainerStyle={styles.contentContainerStyle}
          renderItem={({ item, index }) => (
            <Tag
              type={data.style}
              title={`${item}`}
              selected={
                (selectedItems !== undefined && selectedItems.includes(item)) || onSelect == null
              }
              onPress={onSelect ? () => onSelect(index) : undefined}
            />
          )}
        />
      </Box>
    </Box>
  )
}
